/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ProtectedGroup
 */
export interface ProtectedGroup {
  /**
   *
   * @type {number}
   * @memberof ProtectedGroup
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ProtectedGroup
   */
  name: string;
}

/**
 * Check if a given object implements the ProtectedGroup interface.
 */
export function instanceOfProtectedGroup(value: object): value is ProtectedGroup {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function ProtectedGroupFromJSON(json: any): ProtectedGroup {
  return ProtectedGroupFromJSONTyped(json, false);
}

export function ProtectedGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtectedGroup {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function ProtectedGroupToJSON(value?: Omit<ProtectedGroup, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
